import React, { Suspense, useState } from 'react';
import Hompage from './page/Hompage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import onBoardStore from './redux/onBoardStore';
import { Provider } from 'react-redux';
import QuickGuide from './page/QuickGuide';
import Guide from './page/ToolGuide';
import FadeLoader from "react-spinners/FadeLoader";
import Event from './page/Event';

const loading = true;

loading ? console.log("loading", loading) : null
function App() {
  return (
    <React.Fragment>
      <Suspense
      fallback={<FadeLoader color={"#B70303"} loading={loading} size={100} />}
      >
      <Provider store={onBoardStore}>
        <Router basename="/sale">
          <Routes>
            <Route exact path="/" element={<Hompage />} />
            <Route exact path="/homepage/:id" element={<Hompage />} />
            <Route exact path="/stories" element={<Hompage />} />
            <Route exact path="/guide" element={<Guide />} />
            <Route exact path="/event" element={<Event />} />
            {/* <Route path="/quick-guide" element={<QuickGuide />} /> */}
            <Route path="*" element={<h1>Not Found</h1>} />
          </Routes>
        </Router>
      </Provider>
      </Suspense>
    </React.Fragment>
  );
}

export default App;
